<div class="modal-backdrop">
  <div class="modal-container">
    <div class="modal-image"
	     [ngStyle]="encodedSelectedFileUrl ? 
		{ 'background-image': 'url(' + encodedSelectedFileUrl + ')', 
		'background-size': 'cover', 'background-position': 'center' } : {}">
      <div *ngIf="!showTabs" (click)="toggleTabs()" class="change-cover-btn">
        <mat-icon>edit</mat-icon>
        <span>Change Cover</span>
      </div>

      <div *ngIf="showTabs">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h4 class="p-2 ms-2 page-heading">Choose Cover</h4>
          <button (click)="showTabs = false" class="btn-close me-4"></button>
        </div>
        <div class="upload-container">
          <div class="upload-box">
            <div class="color-grid mb-4">
              <div
                *ngFor="let img of coverImages"
                class="color-box"
                 (click)="selectCoverImage(img)">
			    <img [src]="img" alt="Cover Image" class="img-thumbnail" />

			</div>
            </div>

            <div class="gallery-grid">
              <img
                *ngIf="selectedFileUrl"
                [src]="selectedFileUrl"
                alt="Upload"
                class="upload-icon"
              />
              <button
                *ngIf="selectedFileUrl"
                mat-icon-button
                class="cancel-button"
                (click)="cancelSelectedImage()"
                matTooltip="Cancel Image"
              >
                <mat-icon>cancel</mat-icon>
              </button>

              <div class="choose-device-box" (click)="fileInput.click()">
                <mat-icon>upload_file</mat-icon>
                <span class="choose-text pt-1">Choose from device</span>
              </div>

              <input
                #fileInput
                type="file"
                (change)="onFileSelected($event)"
                accept=".jpg,.png,.svg"
                class="input-image"
                hidden
              />
            </div>
          </div>

          <!-- <div class="justify-content-end d-flex p-3">
            <button
              class="btn-add"
              [disabled]="!createClassroomForm.get('cover_image_url')?.value">
              Add
            </button>
          </div> -->
        </div>
      </div>
    </div>

    <div class="modal-form">
      <span class="close-btn" (click)="closeDialog()">&#x2715;</span>

      <h2 class="create-account">
        {{ data.mode === "edit" ? "Update Classroom" : "Create Classroom" }}
      </h2>
      <p class="sub-head mb-4">
        Set up your classroom to begin creating AI-powered courses, quizzes, and
        assignments.
      </p>

      <form [formGroup]="createClassroomForm">
        <div class="mb-4">
          <label>Classroom Name</label>
          <input
            type="text"
            formControlName="name"
            class="form-control"
            placeholder="e.g., grade 1 section B"
          />
	   <div class="text-danger error-container" *ngIf="createClassroomForm.get('name')?.touched && createClassroomForm.get('name')?.invalid">
      <small class="smaller-text" *ngIf="createClassroomForm.get('name')?.errors?.['required']">
       Classroom Name is required.</small>

            <small class="smaller-text" *ngIf="createClassroomForm.get('name')?.errors?.['pattern']">
        Only letters, numbers, and special characters allowed </small>

	  <small class="smaller-text" *ngIf="createClassroomForm.get('name')?.errors?.['maxlength']">
    Classroom Name cannot exceed 50 characters</small>
   
</div>
        </div>

        <div class="mb-4">
          <label>Subject</label>
          <input
            type="text"
            formControlName="subject"
            class="form-control"
            placeholder="e.g., science, mathematics"
          />

	<div class="text-danger error-container" *ngIf="createClassroomForm.get('subject')?.touched && createClassroomForm.get('subject')?.invalid">
  <small class="smaller-text" *ngIf="createClassroomForm.get('subject')?.errors?.['required']">
    Subject is required.
  </small>

  <small class="smaller-text" *ngIf="createClassroomForm.get('subject')?.errors?.['pattern']">
	Only letters and special characters allowed (numbers and space are not allowed).</small>

  <small class="smaller-text" *ngIf="createClassroomForm.get('subject')?.errors?.['maxlength']">
    Maximum 50 characters allowed.
  </small>
   </div>
        </div>

        <div class="mb-4">
          <label>Grade Level</label>
          <input
            type="text"
            formControlName="grade_level"
            class="form-control"
            placeholder="e.g., grade 1"
          />
	 <div class="text-danger error-container" 
       *ngIf="createClassroomForm.get('grade_level')?.touched && createClassroomForm.get('grade_level')?.invalid">
       
    <small class="smaller-text" *ngIf="createClassroomForm.get('grade_level')?.errors?.['required']">
      Grade Level is required.
    </small>
    
    <small class="smaller-text" *ngIf="createClassroomForm.get('grade_level')?.errors?.['pattern']">
     Only letters and numbers allowed (no special characters and space are not allowed)</small>
    
    <small class="smaller-text" *ngIf="createClassroomForm.get('grade_level')?.errors?.['maxlength']">
      Maximum 20 characters allowed.
    </small>
  </div>
        </div>
        <button
          type="submit"
          class="submit-btn w-100 justify-content-center align-items-center gap-2"
          [disabled]="createClassroomForm.invalid || isCreating"
          (click)="onCreateUpClass()"
        >
  <mat-spinner *ngIf="isCreating" diameter="20" class="me-2"strokeWidth="3"></mat-spinner>
  {{ isCreating ? (data.mode === 'edit' ? 'Updating' : 'Creating') : (data.mode === 'edit' ? 'Update' : 'Create') }} Classroom
</button>
      </form>
    </div>
  </div>
</div>